import { makeTypographyComponent } from '../../../internal/makeTypographyComponent';
export function makeUIText(variantProps) {
  return makeTypographyComponent({
    hardProps: variantProps,
    defaultProps: {
      as: 'span',
      display: 'block',
      color: 'black_100',
      fontWeight: 'normal'
    },
    displayName: 'UIText'
  });
}